import React from "react";
import "./Overview.css";

function Overview() {
  return (
    <>
      <div className="text-[#313F78] md:!px-2 !px-5 !py-10 ">
        <div className="md:flex text-center md:!px-42">
          <div className="md:basis-1/3">
            <h1 className="text-[20px] md:text-[30px] font-semibold md:text-left">Overview</h1>
          </div>
          <div className="md:basis-2/3">
            <h3 className="!text-[14px] md:!text-[30px] font-normal md:text-left">
              We build your tech for a fraction of the price.
            </h3>
            <p className="text-[12px] md:text-[22px] md:text-left">
              Skillioz revolutionizes hiring as an AI-powered Application Tracking System not just
              another recruitment tool. We automate the grind: instantly match CVs to job specs,
              streamline candidate pipelines, and slash time to hire all with smarter, bias-reducing
              AI.
            </p>
          </div>
        </div>
        <div className="video-container md:!px-12">
          <iframe
            style={{ borderRadius: "40px" }}
            width="100%"
            height={window.innerWidth < 768 ? "300" : "650"}
            src="https://www.youtube.com/embed/JCCfdU1sgzg?si=tDfmfTZ56v0048LZ"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <section>
          <div className="text-[#313F78] px-4 md:!px-38">
            <div>
              <h2 className="text-[20px] md:text-[30px] font-semibold text-center !my-5">
                Our Process
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 md:!px-5">
                <div className="bg-[#D5DDFF] rounded-xl !p-5 h-full min-h-[200px] w-full flex flex-col justify-start">
                  <h2 className="text-[20px] md:text-[22px] text-normal !mb-2">
                    AI-Powered CV Matching
                  </h2>
                  <p className="!text-[14px] md:!text-[16px]">
                    3x Better Shortlists with AI That Understands Context Our algorithms analyze 50+
                    data points per resume matching real skills to real needs, not just keywords.
                    Spend time interviewing, not sorting
                  </p>
                </div>
                <div className="bg-[#D5DDFF] rounded-xl !p-5 h-full min-h-[200px] w-full flex flex-col justify-start">
                  <h2 className="text-[20px] md:text-[22px] text-normal !mb-2">
                    All Insights, One Dashboard
                  </h2>
                  <p className="text-[14px] md:text-[16px]">
                    Post jobs, review AI-ranked applicants, and message candidates all from a
                    single, intuitive interface. No more switching tabs or lost resumes. Total
                    hiring visibility, zero chaos.
                  </p>
                </div>
                <div className="bg-[#D5DDFF] rounded-xl !p-5 h-full min-h-[200px] w-full flex flex-col justify-start">
                  <h2 className="text-[20px] md:text-[22px] text-normal !mb-2">
                    Analytics and Reporting
                  </h2>
                  <p className="text-[14px] md:text-[16px]">
                    See beyond resumes: track quality-of-hire trends, predict candidate success, and
                    optimize your entire recruitment funnel. Hire smarter today, build better
                    tomorrow.
                  </p>
                </div>
                <div className="bg-[#D5DDFF] rounded-xl !p-5 h-full min-h-[200px] w-full flex flex-col justify-start">
                  <h2 className="text-[20px] md:text-[22px] text-normal !mb-2">
                    Candidate Management
                  </h2>
                  <p className="text-[14px] md:text-[16px]">
                    Take command of every applicant with tools to sort, score, and advance
                    candidates seamlessly through your hiring stages. Never lose a great prospect to
                    the resume black hole again.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Overview;
